<template>
    <img class="h-8 w-auto sm:h-10" :src="asset('img/logo.svg')" alt="Logo">
</template>
